<template>
    <router-link :to="{name: 'start'}">
        <img class="h-7 4k:h-10 w-48 4k:w-56" src="/bundles/salestool/assets/images/logo.svg">
    </router-link> 
</template>